import React, { Component } from 'react';
import { connect } from "react-redux";
import {handleSaveLatter,handleSavePublicQuote} from "../../../action/quote_order/quote.action.js";
import {handleOrderModal} from "../../../action/quote_order/order.action.js";
import {CheckCaptureModalImage, handleShowExtras} from "../../../action/extra_options/orderExtras.action.js";
import {handleCommonModal,GenrateBuildingDatatoServer,handleProductModal} from "../../../action/quote_order/leadcustomer.action.js";
import {handleShowFullPageLoader,ShowMeasure} from "../../../action/index.js";
import {prepareTwoDMapData,downloadOnClick,autoGeneratedPDF} from "../../../action/2d_mapping/twoDMap.action.js";

class OrderNow extends Component {
  constructor(props) {
    super(props);
  
  }
  onSaveClick = async() => {
       await this.props.downloadOnClick(false);
       await this.props.prepareTwoDMapData();
       //this.props.autoGeneratedPDF();
        if(this.props.const_var.callMesure){
          this.props.ShowMeasure("save")
        }
      };
  onOrderClick = async() => {
       await this.props.downloadOnClick(false);
       await this.props.prepareTwoDMapData();
       this.props.handleOrderModal('open');
        if(this.props.const_var.callMesure){
          this.props.ShowMeasure("save")
        }
      };
  onQuoteClick = async() => {
       await this.props.downloadOnClick(false);
       await this.props.prepareTwoDMapData();
       this.props.handleSaveLatter('open');
        if(this.props.const_var.callMesure){
          this.props.ShowMeasure("save")
        }
      };
  render() {

  return  <>
    <div className="d-none d-lg-block order-now-btn-inn-wrp">
      {this.props.const_var.loginSession == false ? (
        this.props.const_var.isPublicEdit == true ? (
          <button
            onClick={(e) => {
              this.props.handleSavePublicQuote("open");
              this.onSaveClick();
            }}
            className={this.props.const_var.is_loader == false ? "btn btn-primary" : "btn btn-primary disabled"}
          >
            <span className="text">Update Quote</span>
            <span className="icon"><i className="icon-double-arrow-ico"></i></span>
          </button>
        ) : (
          <button
            onClick={
              this.props.const_var.crmSetting.order_now == false || this.props.const_var.checkmoreCustomizeFlag == true || this.props.const_var.crmSetting.main_domain_url == 'metalcarportdepotllc.com' ? (e) => this.onQuoteClick() : (e) => this.onOrderClick()
            }
            className={this.props.const_var.is_loader == false ? "btn btn-primary" : "btn btn-primary disabled"} 
          >
            {this.props.const_var.crmSetting.main_domain_url == 'metalcarportdepotllc.com'? <span className="icon mr-1" style={{display: "flex"}}><i className="icon icon-lock-icon"></i></span> : null}
            <span className="text">
              {this.props.const_var.crmSetting.order_now == false || this.props.const_var.checkmoreCustomizeFlag == true ? "Save Quote" : (this.props.const_var.crmSetting.main_domain_url == 'metalcarportdepotllc.com'? "LOCK IN PRICING" : "Order")}
            </span>
            {this.props.const_var.crmSetting.main_domain_url != 'metalcarportdepotllc.com'? <span className="icon"><i className="icon-double-arrow-ico"></i></span> : null}
          </button>
        )
      ) : this.props.const_var.crmSetting.is_quote_Edit == false ? (
        this.props.const_var.crmSetting.is_module_name == "inventory" ? (
          <button
            onClick={(e) => this.props.handleProductModal()}
            className={this.props.const_var.is_loader == false ? "btn btn-primary" : "btn btn-primary disabled"}
          >
            <span className="text">
              {this.props.const_var.crmSetting.form_action == "edit"
                ? "Update"
                : (this.props.const_var.crmSetting.main_domain_url == "prometalbuildings.com" || this.props.const_var.crmSetting.main_domain_url == "trinitysteelstructures.com" ? "Save & Share" : "Save")}
            </span>
            <span className="icon"><i className="icon-double-arrow-ico"></i></span>
          </button>
        ) : (
          <button
            onClick={
              this.props.const_var.crmSetting.form_action == "edit" &&
              this.props.const_var.i_g_A_y.length > 0
                ? (e) => {
                    this.props.CheckCaptureModalImage("open");
                    this.onSaveClick();
                  }
                : this.props.const_var.loginSession == false
                  ? (e) => {
                      this.onQuoteClick();
                      this.onSaveClick();
                    }
                  : (e) => {
                      this.props.handleCommonModal("lead_customer", "save");
                      this.onSaveClick();
                    }
            }
            className={this.props.const_var.is_loader == false ? "btn btn-primary" : "btn btn-primary disabled"}
          >
            <span className="text">
              {this.props.const_var.crmSetting.form_action == "edit"
                ? "Update"
                : (this.props.const_var.crmSetting.main_domain_url == "prometalbuildings.com" || this.props.const_var.crmSetting.main_domain_url == "trinitysteelstructures.com" ? "Save & Share" : "Save")}
            </span>
            <span className="icon"><i className="icon-double-arrow-ico"></i></span>
          </button>
        )
      ) : this.props.const_var.crmSetting.form_action != "edit" ? (
        <button
          onClick={
            this.props.const_var.crmSetting.order_now == false
              ? (e) => this.onQuoteClick()
              : this.props.const_var.checkmoreCustomizeFlag == true
                ? (e) => this.onQuoteClick()
                : (e) => {
                    this.onOrderClick();
                  }
          }
          className={this.props.const_var.is_loader == false ? "btn btn-primary" : "btn btn-primary disabled"}
        >
          <span className="text">
            {this.props.const_var.crmSetting.order_now == false || this.props.const_var.checkmoreCustomizeFlag == true ? "Save Quote" : "Order" }
          </span>
          <span className="icon"><i className="icon-double-arrow-ico"></i></span>
        </button>
      ) : null}
    </div>
    <div className="d-lg-none order-now-btn-inn-wrp">
      {this.props.const_var.loginSession == false ? (
        this.props.const_var.isPublicEdit == true ? (
          <button
            onClick={(e) => {
              this.props.handleSavePublicQuote("open");
              this.onSaveClick();
            }}
            className={this.props.const_var.is_loader == false ? "btn btn-primary" : "btn btn-primary disabled"}
          >
            <span className="text">Update Quote</span>
            <span className="icon"><i className="icon-double-arrow-ico"></i></span>
          </button>
        ) : (
          <button
            onClick={
              this.props.const_var.crmSetting.order_now == false || this.props.const_var.crmSetting.main_domain_url == 'metalcarportdepotllc.com' ? (e) => this.onQuoteClick() : (e) => { this.onOrderClick(); }
            }
            className={this.props.const_var.is_loader == false ? "btn btn-primary" : "btn btn-primary disabled"}
          >
            {this.props.const_var.crmSetting.order_now == false ? "Quote" : "Order"}
            <span className="icon"><i className="icon-double-arrow-ico"></i></span>
          </button>
        )
      ) : this.props.const_var.crmSetting.is_quote_Edit == false ? (
        this.props.const_var.crmSetting.is_module_name == "inventory" ? (
          <button
            onClick={(e) => this.props.handleProductModal()}
            className={this.props.const_var.is_loader == false ? "btn btn-primary" : "btn btn-primary disabled"}
          >
            <span className="icon"><i className="icon-double-arrow-ico"></i></span>
            <span className="text">
              {this.props.const_var.crmSetting.form_action == "edit"
                ? "Update"
                : (this.props.const_var.crmSetting.main_domain_url == "prometalbuildings.com" || this.props.const_var.crmSetting.main_domain_url == "trinitysteelstructures.com" ? "Save & Share" : "Save")}
            </span>
            <span className="icon"><i className="icon-double-arrow-ico"></i></span>
          </button>
        ) : (
          <button
            onClick={
              this.props.const_var.crmSetting.form_action == "edit" &&
              this.props.const_var.i_g_A_y.length > 0
                ? (e) => {
                    this.props.CheckCaptureModalImage("open");
                    this.onSaveClick();
                  }
                : this.props.const_var.loginSession == false
                  ? (e) => {
                      this.onQuoteClick();
                      this.onSaveClick();
                    }
                  : (e) => {
                      this.props.handleCommonModal("lead_customer", "save");
                      this.onSaveClick();
                    }
            }
            className={this.props.const_var.is_loader == false ? "btn btn-primary" : "btn btn-primary disabled"}
          >
            <span className="text">
              {this.props.const_var.crmSetting.form_action == "edit"
                ? "Update"
                : this.props.const_var.crmSetting.main_domain_url == "prometalbuildings.com" || this.props.const_var.crmSetting.main_domain_url == "trinitysteelstructures.com" ? "Save & Share" : "Save"}
            </span>
            <span className="icon"><i className="icon-double-arrow-ico"></i></span>
          </button>
        )
      ) : this.props.const_var.crmSetting.form_action != "edit" ? (
        <button
          onClick={
            this.props.const_var.crmSetting.order_now == false
              ? (e) => this.onQuoteClick()
              : (e) => {
                  this.onOrderClick();
                }
          }
          className={this.props.const_var.is_loader == false ? "btn btn-primary" : "btn btn-primary disabled"}
        >
          <span className="text">
          {this.props.const_var.crmSetting.order_now == false ? "Quote" : "Order"}
          </span>
          <span className="icon"><i className="icon-double-arrow-ico"></i></span>
        </button>
      ) : null}
    </div>
  </>;


  }
}

const mapStateToProps = (state) => {
  return {...state.reducer}
}

  const mapDispatchToProps = {

  handleProductModal,
  GenrateBuildingDatatoServer,
  CheckCaptureModalImage,
  prepareTwoDMapData,
  downloadOnClick,
  handleShowExtras,
  autoGeneratedPDF,  
  handleSavePublicQuote,
  handleSaveLatter,
  handleOrderModal,
  handleCommonModal,
  handleShowFullPageLoader,
  ShowMeasure
}
  
  export default connect(
  mapStateToProps,
  mapDispatchToProps
  )(OrderNow);


